<template>
    <div>
        <div class="d-flex justify-content-center" style="margin-bottom:10px"><div class="loader"></div></div>
        <div class="text text-tertiary text-center">{{text[lang]}}</div>
    </div>
</template>

<script>
// @ is an alias to /src

export default {
    name: 'loader',
    props: {
        lang: {
            type: String,
            required: true
        },
        text: {
            type: [Object,String],
            default: function() {
                return {
                    es: 'Cargando información...',
                    en: 'Loading information...'
                }
            }
        }
    }
}
</script>